import { graphql } from '@predium/client-graphql';

export const DELETE_ACTIONPLAN = graphql(`
  mutation ActionPlanningActionDeleteActionPlan($actionPlanStableId: Int!) {
    deleteActionPlan(stableId: $actionPlanStableId) {
      stable_id
      __typename
    }
  }
`);

export const BULK_DELETE_ACTION_PLANS = graphql(`
  mutation BulkDeleteActionPlans($input: BulkDeleteActionPlansInput!) {
    bulkDeleteActionPlans(input: $input) {
      deletedCount
      __typename
    }
  }
`);

export const DELETE_ACTION = graphql(`
  mutation DeleteAction($actionId: Int!) {
    deleteAction(action_id: $actionId) {
      message
      error
    }
  }
`);

graphql(`
  fragment BaseEnergyValuesCrremOutput on BaseEnergyValuesCRREMOutput {
    analysisType
    energy_final
    energy_primary
    heating_demand
    co2_emissions
    stranding_date
    efficiency_class
    renovation_costs
    energy_final_cost
    co2_tax_cost
  }
`);

graphql(`
  fragment BaseEnergyValuesNationalEnergyLawOutput on BaseEnergyValuesNationalEnergyLawOutput {
    analysisType
    energy_final
    energy_primary
    heating_demand
    co2_emissions
    efficiency_class
    renovation_costs
    energy_final_cost
    co2_tax_cost
  }
`);

graphql(`
  fragment EnergyValuesCrremOutput on EnergyValuesCRREMOutput {
    analysisType
    energy_final
    energy_primary
    heating_demand
    co2_emissions
    stranding_date
    efficiency_class
    renovation_costs
    energy_final_cost
    co2_tax_cost
    payback_period
    co2_abatement_costs
  }
`);

graphql(`
  fragment EnergyValuesNationalEnergyLawOutput on EnergyValuesNationalEnergyLawOutput {
    analysisType
    energy_final
    energy_primary
    heating_demand
    co2_emissions
    efficiency_class
    renovation_costs
    energy_final_cost
    co2_tax_cost
    payback_period
    co2_abatement_costs
  }
`);

graphql(`
  fragment BaseEnergyValuesOutputResponse on BaseEnergyValuesOutputUnion {
    ...BaseEnergyValuesCrremOutput
    ...BaseEnergyValuesNationalEnergyLawOutput
  }
`);

graphql(`
  fragment EnergyValuesOutputResponse on EnergyValuesOutputUnion {
    ...EnergyValuesCrremOutput
    ...EnergyValuesNationalEnergyLawOutput
  }
`);

graphql(`
  fragment SimulateActionOutputResponse on SimulateActionOutput {
    error
    result {
      ...EnergyValuesCrremOutput
      ...EnergyValuesNationalEnergyLawOutput
    }
  }
`);

graphql(`
  fragment SimulateActionStatusQuoOutputResponse on SimulateActionStatusQuoOutput {
    error
    result {
      ...BaseEnergyValuesCrremOutput
      ...BaseEnergyValuesNationalEnergyLawOutput
    }
  }
`);

graphql(`
  fragment EditActionOutputResponse on EditActionOutput {
    error
    message
  }
`);

export const SIMULATE_ACTION = graphql(`
  mutation SimulateTechnologyAction(
    $action_plan_stable_id: Int!
    $envelope_renovation_parameter: EnvelopeRenovationParameterInput
    $system_renovation_parameter: SystemRenovationParameterInput
    $energy_system_route_renovation_parameter: EnergySystemRouteRenovationParameterInput
    $hydraulic_balancing_renovation_parameter: HydraulicBalancingRenovationParameterInput
    $solar_renovation_parameter: SolarRenovationParameterInput
    $custom_action_renovation_parameter: CustomActionRenovationParameterInput
    $maintenance_action_parameter: MaintenanceActionParameterInput
    $create_ventilation_renovation_parameter: CreateVentilationRenovationParameterInput
    $ventilation_renovation_parameter: VentilationRenovationParameterInput
    $subsidies: [SubsidyInput!]!
    $implementation_to: DateTime!
    $emission_factor_source: emission_factor_source_enum
    $reference_area_type: analysis_reference_area_enum
  ) {
    simulateAction(
      action_plan_stable_id: $action_plan_stable_id
      custom_action_renovation_parameter: $custom_action_renovation_parameter
      envelope_renovation_parameter: $envelope_renovation_parameter
      system_renovation_parameter: $system_renovation_parameter
      energy_system_route_renovation_parameter: $energy_system_route_renovation_parameter
      hydraulic_balancing_renovation_parameter: $hydraulic_balancing_renovation_parameter
      solar_renovation_parameter: $solar_renovation_parameter
      maintenance_action_parameter: $maintenance_action_parameter
      create_ventilation_renovation_parameter: $create_ventilation_renovation_parameter
      ventilation_renovation_parameter: $ventilation_renovation_parameter
      subsidies: $subsidies
      implementation_to: $implementation_to
      emission_factor_source: $emission_factor_source
      reference_area_type: $reference_area_type
    ) {
      ...SimulateActionOutputResponse
    }
  }
`);

export const IMPLEMENT_ACTION = graphql(`
  mutation ImplementAction(
    $action_plan_stable_id: Int!
    $implementation_from: DateTime!
    $implementation_to: DateTime!
    $envelope_renovation_parameter: EnvelopeRenovationParameterInput
    $system_renovation_parameter: SystemRenovationParameterInput
    $energy_system_route_renovation_parameter: EnergySystemRouteRenovationParameterInput
    $hydraulic_balancing_renovation_parameter: HydraulicBalancingRenovationParameterInput
    $solar_renovation_parameter: SolarRenovationParameterInput
    $custom_action_renovation_parameter: CustomActionRenovationParameterInput
    $maintenance_action_parameter: MaintenanceActionParameterInput
    $create_ventilation_renovation_parameter: CreateVentilationRenovationParameterInput
    $ventilation_renovation_parameter: VentilationRenovationParameterInput
    $subsidies: [SubsidyInput!]!
    $customCost: CustomCostInput
  ) {
    implementAction(
      action_plan_stable_id: $action_plan_stable_id
      implementation_from: $implementation_from
      implementation_to: $implementation_to
      envelope_renovation_parameter: $envelope_renovation_parameter
      system_renovation_parameter: $system_renovation_parameter
      energy_system_route_renovation_parameter: $energy_system_route_renovation_parameter
      hydraulic_balancing_renovation_parameter: $hydraulic_balancing_renovation_parameter
      solar_renovation_parameter: $solar_renovation_parameter
      custom_action_renovation_parameter: $custom_action_renovation_parameter
      maintenance_action_parameter: $maintenance_action_parameter
      create_ventilation_renovation_parameter: $create_ventilation_renovation_parameter
      ventilation_renovation_parameter: $ventilation_renovation_parameter
      subsidies: $subsidies
      customCost: $customCost
    ) {
      action_id
    }
  }
`);

export const SIMULATE_EDIT_ACTION = graphql(`
  mutation SimulateEditAction(
    $action_id: Int!
    $envelope_renovation_parameter: EnvelopeRenovationParameterInput
    $system_renovation_parameter: SystemRenovationParameterInput
    $energy_system_route_renovation_parameter: EnergySystemRouteRenovationParameterInput
    $hydraulic_balancing_renovation_parameter: HydraulicBalancingRenovationParameterInput
    $solar_renovation_parameter: SolarRenovationParameterInput
    $custom_action_renovation_parameter: CustomActionRenovationParameterInput
    $maintenance_action_parameter: MaintenanceActionParameterInput
    $create_ventilation_renovation_parameter: CreateVentilationRenovationParameterInput
    $ventilation_renovation_parameter: VentilationRenovationParameterInput
    $subsidies: [SubsidyInput!]!
    $customCost: CustomCostInput
    $implementation_to: DateTime!
    $emission_factor_source: emission_factor_source_enum
    $reference_area_type: analysis_reference_area_enum
  ) {
    simulateEditAction(
      action_id: $action_id
      implementation_to: $implementation_to
      envelope_renovation_parameter: $envelope_renovation_parameter
      system_renovation_parameter: $system_renovation_parameter
      energy_system_route_renovation_parameter: $energy_system_route_renovation_parameter
      hydraulic_balancing_renovation_parameter: $hydraulic_balancing_renovation_parameter
      solar_renovation_parameter: $solar_renovation_parameter
      custom_action_renovation_parameter: $custom_action_renovation_parameter
      maintenance_action_parameter: $maintenance_action_parameter
      create_ventilation_renovation_parameter: $create_ventilation_renovation_parameter
      ventilation_renovation_parameter: $ventilation_renovation_parameter
      subsidies: $subsidies
      customCost: $customCost
      emission_factor_source: $emission_factor_source
      reference_area_type: $reference_area_type
    ) {
      ...SimulateActionOutputResponse
    }
  }
`);

export const EDIT_ACTION = graphql(`
  mutation EditAction(
    $action_id: Int!
    $envelope_renovation_parameter: EnvelopeRenovationParameterInput
    $system_renovation_parameter: SystemRenovationParameterInput
    $energy_system_route_renovation_parameter: EnergySystemRouteRenovationParameterInput
    $hydraulic_balancing_renovation_parameter: HydraulicBalancingRenovationParameterInput
    $solar_renovation_parameter: SolarRenovationParameterInput
    $custom_action_renovation_parameter: CustomActionRenovationParameterInput
    $maintenance_action_parameter: MaintenanceActionParameterInput
    $create_ventilation_renovation_parameter: CreateVentilationRenovationParameterInput
    $ventilation_renovation_parameter: VentilationRenovationParameterInput
    $subsidies: [SubsidyInput!]!
    $customCost: CustomCostInput
    $implementation_to: DateTime!
  ) {
    editAction(
      action_id: $action_id
      implementation_to: $implementation_to
      envelope_renovation_parameter: $envelope_renovation_parameter
      system_renovation_parameter: $system_renovation_parameter
      energy_system_route_renovation_parameter: $energy_system_route_renovation_parameter
      hydraulic_balancing_renovation_parameter: $hydraulic_balancing_renovation_parameter
      solar_renovation_parameter: $solar_renovation_parameter
      custom_action_renovation_parameter: $custom_action_renovation_parameter
      maintenance_action_parameter: $maintenance_action_parameter
      create_ventilation_renovation_parameter: $create_ventilation_renovation_parameter
      ventilation_renovation_parameter: $ventilation_renovation_parameter
      subsidies: $subsidies
      customCost: $customCost
    ) {
      ...EditActionOutputResponse
    }
  }
`);

export const CREATE_ACTION_PLAN = graphql(`
  mutation CreateActionPlanModalCreateActionPlan($scenario_id: Int!, $building_id: Int!) {
    createActionPlan(input: { building_id: $building_id, scenario_id: $scenario_id }) {
      stable_id
    }
  }
`);

export const CREATE_SCENARIO = graphql(`
  mutation CreateScenarioModalCreateScenario($description: String!, $name: String!, $portfolio_id: Int) {
    createScenario(input: { portfolio_id: $portfolio_id, name: $name, description: $description }) {
      id
    }
  }
`);

export const DELETE_SCENARIO = graphql(`
  mutation ActionPlanningScenarioDeleteScenario($id: Int!) {
    deleteScenario(input: { scenario_id: $id }) {
      id
    }
  }
`);

export const ARCHIVE_SCENARIO = graphql(`
  mutation ActionPlanningScenarioArchiveScenario($id: Int!) {
    archiveScenario(scenario_id: $id) {
      id
    }
  }
`);

export const UNARCHIVE_SCENARIO = graphql(`
  mutation ActionPlanningScenarioUnarchiveScenario($id: Int!) {
    unarchiveScenario(scenario_id: $id) {
      id
    }
  }
`);

export const UPDATE_SCENARIO = graphql(`
  mutation UpdateScenario($id: Int!, $name: String!, $description: String) {
    updateScenario(input: { scenario_id: $id, name: $name, description: $description }) {
      id
    }
  }
`);

export const DUPLICATE_SCENARIO = graphql(`
  mutation DuplicateScenario($scenarioId: Int!, $copyNameSuffix: String!) {
    duplicateScenario(input: { scenario_id: $scenarioId, copy_name_suffix: $copyNameSuffix })
  }
`);

export const UPDATE_SCENARIO_TO_LATEST_VERSION = graphql(`
  mutation UpdateScenarioToLatestVersion($id: Int!) {
    updateScenarioToLatestVersion(id: $id)
  }
`);

export const CREATE_BULK_ACTION = graphql(`
  mutation CreateBulkAction($input: BulkActionInput!) {
    bulkActionId: createBulkAction(input: $input)
  }
`);

export const EDIT_BULK_ACTION = graphql(`
  mutation EditBulkAction($input: BulkActionEditInput!) {
    editBulkAction(input: $input) {
      message
    }
  }
`);

export const DELETE_BULK_ACTION = graphql(`
  mutation DeleteBulkAction($id: Int!) {
    deleteBulkAction(id: $id)
  }
`);

export const CREATE_EXCLUSION_NOTE = graphql(`
  mutation CreateExclusionNote($actionPlanStableId: Int!, $implementationTo: DateTime!, $note: String!) {
    createExclusionNote(action_plan_stable_id: $actionPlanStableId, implementation_to: $implementationTo, note: $note) {
      action_id
    }
  }
`);

export const EDIT_EXCLUSION_NOTE = graphql(`
  mutation EditExclusionNote($actionId: Int!, $implementationTo: DateTime!, $note: String!) {
    editExclusionNote(action_id: $actionId, implementation_to: $implementationTo, note: $note) {
      message
    }
  }
`);
